export const basicMetricsLabels: Record<string, string> = {
  DiabetesRequiringInsulin: "Diabetes Requiring Insulin",
  Hypertension: "Hypertension",
  LiverDisease: "Liver Disease",
  KidneyStones5Yrs: "Kidney Stones",
  ProteinInUrine: "Protein in Urine",
  BloodInUrine: "Blood in Urine",
  HeartDisease: "Heart Disease",
  ActiveCancer: "Active Cancer",
  PastCancerHistory: "Past Cancer History",
  BleedingOrClottingProblem: "Bleeding or Clotting Problem",
  SubstanceDependence: "Substance Dependence",
  Relationship: "Relationship",
  DonorMotivationLevel: "Donor Motivation Level"
};

export const healthHistoryLabels: Record<string, string> = {
  KidneyHealthHistory: "Kidney Health History",
  GeneralHealthHistory: "General Health History",
  EyeHealthHistory: "Eye Health History",
  HeadAndNeckHealthHistory: "Head and Neck Health History",
  HeartHealthHistory: "Heart Health History",
  RespiratoryHealthHistory: "Respiratory Health History",
  GastrointestinalHealthHistory: "Gastrointestinal Health History",
  GenitourinaryHealthHistory: "Genitourinary Health History",
  MuscularHealthHistory: "Muscular Health History",
  SkinHealthHistory: "Skin Health History",
  MedicalHistory: "Medical History",
  NeurologicalHealthHealthHistory: "Neurological Health History",
  EndocrineHealthHealthHistory: "Endocrine Health History",
  HematologicalHealthHistory: "Hematological Health History",
  EnvironmentalAllergies: "Environmental Allergies",
  FoodAllergies: "Food Allergies",
  Medications: "Medications",
  SurgicalHistory: "Surgical History",
  MensHealthHistory: "Men's Health History",
  WomensHealthHistory: "Women's Health History",
};

export const familyHistoryLabels: Record<string, string> = {
  KidneyDiseaseFamilyHistory: "Kidney Disease",
  HypertensionFamilyHistory: "Hypertension",
  DiabetesFamilyHistory: "Diabetes",
  TuberculosisFamilyHistory: "Tuberculosis",
  LupusFamilyHistory: "Lupus",
  LiverFamilyHistory: "Liver Disease",
  HeartDiseaseFamilyHistory: "Heart Disease",
  MelanomaFamilyHistory: "Melanoma",
  BasalCellCarcinomaFamilyHistory: "Basal Cell Carcinoma",
  SquamousCellCarcinomaFamilyHistory: "Squamous Cell Carcinoma",
};

export const statusMapping: Record<string, string> = {
  "Consent Sent": "status-sent",
  "Consent Viewed": "status-viewed",
  "Consent Signed": "status-signed",
  "Consent Declined": "status-declined",
};

export const donorBasicMetricKeys = [
  "DiabetesRequiringInsulin",
  "Hypertension",
  "LiverDisease",
  "KidneyStones5Yrs",
  "ProteinInUrine",
  "BloodInUrine",
  "HeartDisease",
  "ActiveCancer",
  "PastCancerHistory",
  "BleedingOrClottingProblem",
  "SubstanceDependence",
  "Relationship",
  "DonorMotivationLevel"
];

export const donorPhysicalAndMentalKeys = [
  "PHSPositive",
  "PhysicalFitnessScore",
  "PHQ9Score",
  "GAD7Score",
  "MentalHealthHistory",
];

export const donorHealthHistoryKeys = [
  "KidneyHealthHistory",
  "GeneralHealthHistory",
  "EyeHealthHistory",
  "HeadAndNeckHealthHistory",
  "HeartHealthHistory",
  "RespiratoryHealthHistory",
  "GastrointestinalHealthHistory",
  "GenitourinaryHealthHistory",
  "MuscularHealthHistory",
  "SkinHealthHistory",
  "MedicalHistory",
  "NeurologicalHealthHealthHistory",
  "EndocrineHealthHealthHistory",
  "HematologicalHealthHistory",
  "EnvironmentalAllergies",
  "FoodAllergies",
  "Medications",
  "SurgicalHistory",
  "MensHealthHistory",
  "WomensHealthHistory",
];

export const donorFamilyHistoryKeys = [
  "KidneyDiseaseFamilyHistory",
  "HypertensionFamilyHistory",
  "DiabetesFamilyHistory",
  "TuberculosisFamilyHistory",
  "LupusFamilyHistory",
  "LiverFamilyHistory",
  "HeartDiseaseFamilyHistory",
  "MelanomaFamilyHistory",
  "BasalCellCarcinomaFamilyHistory",
  "SquamousCellCarcinomaFamilyHistory",
];

export const donorSocialHistoryKeys = [
  "TobaccoOrNicotineUse",
  "AlcoholUse",
  "DrugUse",
  "MedicalInsurance"
];

export const donorDietHistoryKeys = ["SpecialDiet", "Supplements"];

export type SynopsisMetricValueKind = "signal" | "score" | "alwaysDisplay" | "profileOnly";
export type SynopsisMetricRiskDirection = "standard" | "reverse";

export interface SynopsisMetricRule {
  valueKind?: SynopsisMetricValueKind;
  riskDirection?: SynopsisMetricRiskDirection;
  requiresResponseContextForCleared?: boolean;
  requiredGender?: "male" | "female";
}

export const synopsisMetricRules: Record<string, SynopsisMetricRule> = {
  Relationship: { valueKind: "profileOnly" },
  DonorMotivationLevel: { valueKind: "alwaysDisplay" },
  PhysicalFitnessScore: { valueKind: "score" },
  PHQ9Score: { valueKind: "score" },
  GAD7Score: { valueKind: "score" },
  MentalHealthHistory: { requiresResponseContextForCleared: true },
  MensHealthHistory: { requiredGender: "male" },
  WomensHealthHistory: { requiredGender: "female" },
  MedicalInsurance: { riskDirection: "reverse" },
};

export const physicalAndMentalHistoryLabels: Record<string, string> = {
  PHSPositive: "Risk Screening",
  PhysicalFitnessScore: "Physical Fitness Score",
  PHQ9Score: "PHQ-9",
  GAD7Score: "GAD-7",
  "MentalHealthHistory": "Mental Health History"
};

export const socialHistoryLabels: Record<string, string> = {
  TobaccoOrNicotineUse: "Tobacco/Nicotine Use",
  AlcoholUse: "Alcohol Use",
  DrugUse: "Drug Use",
  MedicalInsurance: "Medical Insurance",
};

export const dietHistoryLabels: Record<string, string> = {
  SpecialDiet: "Special Diet",
  Supplements: "Nutritional Supplements",
};
